import { defineMessages } from "react-intl";

const CONSENT_DATE_NOTIFICATION = "consent-date-notification";

const consentDateNotificationMessages = defineMessages({
  consentDate: {
    id: `${CONSENT_DATE_NOTIFICATION}.consent-date`,
    defaultMessage: `You gave consent to EBSCO to retain your personal data on {consentDateTime}.`,
    description:
      "Notification telling a user what date they gave consent for data retention"
  }
});

export default consentDateNotificationMessages;
